import InputValidator from "Helpers/InputValidator";

require("es6-promise").polyfill();
require("isomorphic-fetch");

export default function ContactForm(container) {
  const containerActiveClass = container.getAttribute("data-active-class");
  const form = container.querySelector(".js-contact-form");
  form.setAttribute("novalidate", true);
  const url = form.action;

  const inputsValidating = container.querySelectorAll(".js-text-field-input");
  const inputsValidators = [];

  for (let i = 0, len = inputsValidating.length; i < len; i++) {
    const inputInvalidClass = inputsValidating[i].getAttribute(
      "data-invalid-class"
    );

    const inputValidator = new InputValidator({
      domElement: inputsValidating[i],
      requiredFlag: true,
      errorClass: inputInvalidClass
    });
    inputsValidators.push(inputValidator);
  }

  form.addEventListener("submit", function submitContactForm(e) {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      const data = new FormData(form);
      data.append("ajax", "Y");
      makeRequest(url, data);
    }
  });

  function makeRequest(urlForm, data) {
    fetch(urlForm, {
      method: "POST",
      body: data,
      credentials: "same-origin"
    })
      .then(function requestSuccess(response) {
        if (response.ok) {
          return response.blob();
        }

        throw new Error("Network response was not ok.");
      })
      .then(function requestResponse() {
        handleResponse();
      });
  }

  function handleResponse() {
    container.classList.add(containerActiveClass);
  }

  function validateTextInputs(inputsValidatorsList) {
    let isValid = true;

    for (let i = 0, len = inputsValidatorsList.length; i < len; i++) {
      const isFormElementValid = inputsValidatorsList[i].validate();
      if (!isFormElementValid) {
        isValid = false;
      }
    }

    return isValid;
  }

  function validateForm() {
    let isValid = true;

    const isTextInputsValid = validateTextInputs(inputsValidators);

    if (!isTextInputsValid) {
      isValid = false;
    }

    return isValid;
  }
}
